import { logger } from './logger'

class TaskManager {
  private tasks: Promise<unknown>[]

  constructor() {
    this.tasks = []
  }

  addTask = (task: Promise<unknown>) => {
    this.tasks.push(task)
  }

  waitAllTasks = async () => {
    await Promise.all(this.tasks).catch((e) =>
      logger.error('Error occurred while waiting for cart tasks', e)
    )
    this.tasks = []
  }

  hasTasksInQueue = async () => {
    if (!this.tasks.length) {
      return false
    }

    return Promise.race([
      new Promise(this.waitAllTasks).then(() => false),
      new Promise((resolve) => setTimeout(() => resolve(true), 0)),
    ])
  }
}

export const taskManager = new TaskManager()
